"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.StyledInput = exports.Container = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Text = _styledComponents.default.span.withConfig({
  displayName: "Text"
})(["margin:0 auto 0 0.2vw;font-size:1.4rem;line-height:120%;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.typo.highlight;
});

exports.Text = Text;

var StyledInput = _styledComponents.default.input.withConfig({
  displayName: "StyledInput"
})(["position:absolute;opacity:0;width:0;height:0;"]);

exports.StyledInput = StyledInput;
StyledInput.displayName = 'StyledInput';

var Container = _styledComponents.default.label.withConfig({
  displayName: "Container"
})(["display:flex;align-items:center;justify-content:flex-end;width:25.4vw;height:75px;min-width:300px;cursor:pointer;background:#ffffff;border:1px solid;border-color:", ";border-radius:2px;font-family:", ";font-size:1.6rem;", "{color:", ";}svg{fill:", ";}svg{margin:auto 1.6vw;fill:", ";}", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.ui.outline;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
}, Text, function (_ref4) {
  var disabled = _ref4.disabled,
      theme = _ref4.theme;
  return disabled ? theme.ui.outline : null;
}, function (_ref5) {
  var disabled = _ref5.disabled,
      theme = _ref5.theme;
  return disabled ? theme.ui.outline : null;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.ui.interactive;
}, function (_ref7) {
  var checked = _ref7.checked,
      theme = _ref7.theme;
  return checked ? (0, _styledComponents.css)(["background-color:", ";border-color:", ";", "{color:", ";}svg{fill:", ";path{fill:", ";}}"], theme.brand.lightest, theme.brand.secondary, Text, theme.brand.primary, theme.brand.primary, theme.brand.primary) : null;
});

exports.Container = Container;